<template>
  <div class="content-center">
    <div class="md:basis-1/2 p-2">
      <div class=" mx-auto">
        <template v-if="ready">
          <div class="w-full text-3xl font-bold p-4 mb-10 text-center border-b border-black relative">
            <p class="font-title text-4.3xl">Event</p>
<!--            <NuxtLink to="/event">-->
<!--              <div class="flex items-center absolute left-[15px] bottom-[-17px] bg-black text-white font-normal py-1.5 px-3 text-base">-->
<!--                <img src="/icons/left-arr-white.svg" class="w-5 h-5" alt="arrow right">-->
<!--                Back to Calendar-->
<!--              </div>-->
<!--            </NuxtLink>-->
          </div>
          <div class="flex flex-col border-black border p-4 lg:py-10 lg:px-20">
            <p class="font-title text-4.3xl mb-10 w-full text-center">{{form.name}}</p>
            <div class="flex flex-col lg:flex-row justify-between">
              <div class="w-full flex-grow lg:max-w-[600px] mb-3 lg:mb-0">
                <div class="flex flex-col border-[#050708] border-b-2 mb-3 pb-4">
                  <div class="flex flex-row">
                    <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                      <img src="/icons/calendar-black.svg" class="w-4 h-4 mr-2" alt="calendar">
                      <p>Date: </p>
                    </div>
                    <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                      <p>{{form.date_start}} - {{form.date_end}} </p>
                    </div>
                  </div>
                  <div class="flex flex-row">
                    <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                      <img src="/icons/location.svg" class="w-4 h-4 mr-2" alt="location">
                      <p>Location: </p>
                    </div>
                    <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium flex-col">
                      <p> {{form.location}} </p>
                      <p>{{ location }}</p>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center ">
                    <img src="/icons/user-icon.svg" class="w-4 h-4 mr-2" alt="user icon">
                    <p>Contact: </p>
                  </div>
                  <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                    <p>{{ form.contact }} </p>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                    <img src="/icons/phone-icon.svg" class="w-4 h-4 mr-2" alt="phone icon">
                    <p>Phone: </p>
                  </div>
                  <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                    <a class="text-darkRed underline cursor-pointer" :href="'tel:'+form.contact_phone"> {{ form.contact_phone }} </a>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                    <img src="/icons/email-icon.svg" class="w-4 h-4 mr-2" alt="email icon">
                    <p>Email: </p>
                  </div>
                  <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                    <a class="text-darkRed underline cursor-pointer" :href="'mailto:'+form.contact_email"> {{ form.contact_email }} </a>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                    <img src="/icons/link-icon.svg" class="w-4 h-4 mr-2" alt="link icon">
                    <p>Link: </p>
                  </div>
                  <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                    <NuxtLink :href="(form.link && form.link.includes('http'))?form.link:('https://'+form.link)" class="text-darkRed underline cursor-pointer"> {{ form.link }} </NuxtLink>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2 flex items-center">
                    <img src="/icons/faceb-icon.svg" class="w-4 h-4 mr-2" alt="link icon">
                    <p>Facebook: </p>
                  </div>
                  <div class="w-full sm:flex-grow text-tiny font-normal	sm:font-medium">
                    <NuxtLink :href="(form.facebook && form.facebook.includes('http'))?form.facebook:('https://'+form.facebook)" class="text-darkRed underline cursor-pointer"> {{ form.facebook }} </NuxtLink>
                  </div>
                </div>

<!--                <div class="flex flex-row">-->
<!--                  <div class="w-full font-bold sm:w-[120px] text-tiny mb-2">-->
<!--                    <p>Notes: </p>-->
<!--                  </div>-->
<!--                  <div class="w-full sm:flex-grow text-tiny">-->
<!--                    <p> {{ form.details }} </p>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="flex justify-between">
                <div class="flex lg:min-w-[300px] flex-col">
                  <div>
                  <p class="font-bold sm:w-[120px] text-base mb-4">Associated files:</p>
                  <div class="flex">
                    <a v-if="form.advertisement" :href="form.advertisement">
                      <img src="/icons/view-ad.png" alt="advertisement" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.entry_form" :href="form.entry_form">
                      <img src="/icons/entry_form.png" alt="entry_form"
                           class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="photo_link" :href="photo_link">
                      <img src="/icons/icon_d.png" alt="photo_link"
                           class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.misc1" :href="form.misc1">
                      <img src="/icons/pdf_flat.png" alt="misc1" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.misc2" :href="form.misc2">
                      <img src="/icons/pdf_flat.png" alt="misc2" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.misc3" :href="form.misc3">
                      <img src="/icons/pdf_flat.png" alt="misc3" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.misc4" :href="form.misc4">
                      <img src="/icons/pdf_flat.png" alt="misc4" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.misc5" :href="form.misc5">
                      <img src="/icons/pdf_flat.png" alt="misc5" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.prize_list" :href="form.prize_list">
                      <img src="/icons/prize_list.png" alt="prize_list"
                           class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                    <a v-if="form.show_schedule" :href="form.show_schedule">
                      <img src="/icons/show_schedule.png" alt="show_schedule"
                           class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
                    </a>
                  </div>
                  </div>
                  <div>
                  <p class="font-bold sm:w-[120px] text-base mb-4">Results:</p>
                  <div class="flex">
                    <NuxtLink v-if="results_data.aa" to="/all-american-standings" aria-label="all-american-standings"  class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) 0 0 no-repeat;width:62px;height:62px;"/>
                    <NuxtLink v-if="results_data.result" :to="'/horse-shows/'+calendarEvent_id" :aria-label="calendarEvent_id"  class="block hover:opacity-70 ease-in-out"  style="background: url(/img/horse_shows_buttons.png) -62px 0 no-repeat;width:62px;height:62px;"/>
                    <!--/*      <a href="#" class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) -62px 0 no-repeat;width:62px;height:62px;"></a>*/-->
                    <NuxtLink v-if="results_data.albums" :to="'/horse-shows/'+calendarEvent_id+'/photos'" :aria-label="calendarEvent_id+'-photos'"  class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) -126px 0 no-repeat;width:62px;height:62px;"/>
                    <NuxtLink v-if="results_data.videos" :to="'/horse-shows/'+calendarEvent_id+'/videos'" :aria-label="calendarEvent_id+'-videos'"  class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) -189px 0 no-repeat;width:62px;height:62px;"/>
                    <NuxtLink v-if="results_data.judge_cards" :to="'/horse-shows/'+calendarEvent_id+'/judgecards'" :aria-label="calendarEvent_id+'-judgecards'"  class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) -313px 0 no-repeat;width:62px;height:62px;"/>
                    <NuxtLink v-if="results_data.photo_link" :to="results_data.photo_link" :aria-label="results_data.photo_link"  class="block hover:opacity-70 ease-in-out" style="background: url(/img/horse_shows_buttons.png) -375px 0 no-repeat;width:62px;height:62px;"/>
                  </div>
                  </div>
                </div>


                <div class=" mb-2 sm:mb-0 w-auto sm:w-[180px] flex justify-center">
                  <div class="flex justify-between sm:flex-col">
                    <div class="flex mb-2 flex-col ">
                      <div class="bg-black flex mb-2 justify-center items-center px-6 py-2">
                        <div class="cursor-pointer" v-on:click="shareOn('facebook')">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1"  height="48" x="0" y="0" viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-black w-8 h-8 sm:w-12 sm:h-12 p-2 sm:p-3.5 rounded-full hover:opacity-70 bg-white mr-2"><g>
          <g xmlns="http://www.w3.org/2000/svg">
            <path id="f_1_" style="" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"  data-original="#010002"/>
          </g></g></svg>
                        </div>
                        <p class="uppercase text-white text-2xl">share</p>
                      </div>
                      <div class="bg-black flex justify-center items-center p-2">
                        <div class="cursor-pointer" v-on:click="shareOn('twitter')">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-black w-8 h-8 sm:w-12 sm:h-12 p-2 sm:p-3.5 rounded-full hover:opacity-75 bg-white mr-2"><g>
          <g xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z" data-original="#000000" class=""/>
            </g>
          </g>
          </g></svg>
                        </div>
                        <p class="uppercase text-white text-2xl">share</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <loaders-spinner/>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
import {http} from "~/utils/http";
import {CalendarEvent,Page} from "~/composables/nhTypes";
import {computed, ref} from "vue";
import {useSiteURL,useSiteTitle, useSiteWeb} from "~/composables/state";
import {useMainStore} from "@/stores/main";
import {useHead} from "nuxt/app";

const mainStore = useMainStore();
const siteWeb = useSiteWeb();
const titleStack = ref(['Admin / Pages', 'Calendar', 'Edit Event'])
const form = ref(new CalendarEvent());
const photo_link = ref(null);
const location = ref('');
const ready = ref(false);
const route = useRoute();
const calendarEvent_id = route.params.slug;
const siteURL = useSiteURL();
const page = ref(new Page());
const siteTitle = useSiteTitle();
const arabian = ref(siteTitle.value.includes('Arabian'));

const results_data = ref({
  aa:null,
  albums:null,
  videos:null,
  judge_cards:null,
  photo_link:null,
  result:null,
});


useHead({
  title: computed(() => page.value.meta_title + ' - ' + siteTitle.value) ,
  meta: [
    {name: 'description', content: computed(() => page.value.meta_description?? siteTitle.value)},
    {name: 'keywords', content: computed(() => page.value.meta_keywords?? siteTitle.value)},
    { property: 'og:title', content: computed(() => page.value.meta_title + siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => page.value.meta_description?? siteTitle.value) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
  ],
})

const getEvent = async () => {
  try {
    await http
        .get("/api/event/calendar_" + calendarEvent_id)
        .then((response) => {

          form.value = response.data.show_result;
          form.value.prize_list = response.data.show_result.prize_list ? siteURL.value + response.data.show_result.prize_list : null;
          form.value.show_schedule = response.data.show_result.show_schedule ? siteURL.value + response.data.show_result.show_schedule : null;
          form.value.entry_form = response.data.show_result.entry_form ? siteURL.value + response.data.show_result.entry_form : null;
          form.value.misc1 = response.data.show_result.misc1 ? siteURL.value + response.data.show_result.misc1 : null;
          form.value.misc2 = response.data.show_result.misc2 ? siteURL.value + response.data.show_result.misc2 : null;
          form.value.misc3 = response.data.show_result.misc3 ? siteURL.value + response.data.show_result.misc3 : null;
          form.value.misc4 = response.data.show_result.misc4 ? siteURL.value + response.data.show_result.misc4 : null;
          form.value.misc5 = response.data.show_result.misc5 ? siteURL.value + response.data.show_result.misc5 : null;
          form.value.advertisement = response.data.show_result.advertisement ? siteURL.value + response.data.show_result.advertisement : null;
          photo_link.value = response.data.show_result.result ? (response.data.show_result.result.photo_link ?? null) : null;
          form.value.aaq = !!form.value.aaq;

          let aa = false;

          if(response.data.show_result.result){
            let diff = new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_end)) - new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(response.data.show_result.date_start))

            if (response.data.show_result.result.usaf === 1 && response.data.show_result.result.nr_of_horses > 1 && ((!arabian.value && diff >= 2) || arabian.value)) {
              aa = true;
            }

            results_data.value.aa = aa;
            results_data.value.albums = response.data.show_result.albums.length > 0;
            results_data.value.videos = response.data.show_result.videos.length > 0;
            results_data.value.result = true;
            results_data.value.judge_cards = response.data.show_result.judge_cards.length > 0;
            results_data.value.photo_link = photo_link.value;
          }



          form.value.date_start = new Intl.DateTimeFormat('default', {    timeZone: 'utc',weekday: 'long'}).format(new Date(form.value.date_start)) +
          ", "+  new Intl.DateTimeFormat('default', {    timeZone: 'utc',month: 'long'}).format(new Date(form.value.date_start)) + " " +
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(form.value.date_start)) + ", " +
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',year: 'numeric'}).format(new Date(form.value.date_start))
          ;

          form.value.date_end = new Intl.DateTimeFormat('default', {    timeZone: 'utc',weekday: 'long'}).format(new Date(form.value.date_end)) +
          ", "+  new Intl.DateTimeFormat('default', {    timeZone: 'utc',month: 'long'}).format(new Date(form.value.date_end)) + " " +
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(form.value.date_end)) + ", " +
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',year: 'numeric'}).format(new Date(form.value.date_end))
          ;


          // let date_start =  new Date(form.value.date_start);
          // let date_end =  new Date(form.value.date_end);

          // form.value.date_start = date_start.toLocaleString('default', {    timeZone: 'utc',weekday: 'long'})+', '+ date_start.toLocaleString('default',{month:'long'}) + ' ' + date_start.getDate()+ ', '+ date_start.getFullYear();
          // form.value.date_end = date_end.toLocaleString('default', {    timeZone: 'utc',weekday: 'long'})+', '+ date_end.toLocaleString('default',{month:'long'}) + ' ' + date_end.getDate()+ ', '+ date_end.getFullYear();

          location.value = form.value.city + (form.value.state_province ? (', ' + form.value.state_province.abbreviation) : '');
          page.value.meta_title = form.value.meta_title ;
          page.value.meta_description = form.value.meta_description ;
          page.value.meta_keywords =form.value.meta_keywords ;
        });
  } catch (e) {
  }
};


const shareOn = (type) => {
  const url = siteWeb.value+'/event/view/' + calendarEvent_id;
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-500,top=-500`;
  if(type === 'facebook'){
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank',params)
  }
  if(type === 'twitter') {
    window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', params)
  }
}

const start = async () => {
  ready.value = false;
  await getEvent();
  ready.value = true;
}

await start();
</script>
